import React from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Link from '@atlaskit/link';

import { useSessionData } from '@confluence/session-data';

import { SET_UP_AND_MANAGE_DOCUMENTATION, DATA_SECURITY_POLICY_DOCUMENTATION } from './constants';

export type LearnMoreLinkProps = {
	children: React.ReactNode;
	screenSource: string;
	analyticsAttributes?: {};
	isSpaceBlockedByOrg?: boolean;
};

export const LearnMoreLink = ({
	children,
	screenSource,
	analyticsAttributes,
	isSpaceBlockedByOrg,
}: LearnMoreLinkProps) => {
	const { edition } = useSessionData();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: screenSource,
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'publicLinksLearnMoreLink',
				attributes: {
					...analyticsAttributes,
					edition,
				},
			},
		}).fire();
	};

	const url = isSpaceBlockedByOrg
		? DATA_SECURITY_POLICY_DOCUMENTATION
		: SET_UP_AND_MANAGE_DOCUMENTATION;

	return (
		<Link target="_blank" rel="noopener noreferrer" href={url} onClick={onClick}>
			{children}
		</Link>
	);
};
